module.exports = require("lodash/has");